import { ReactNode, useEffect, useRef } from 'react';
import { useAuthStore } from '@store/useAuthStore';
import { refreshAccessToken } from '@api/axiosInstance';
import { adminAuthControllerMe } from '@api/sweetnya/admin-auth/admin-auth';

type AuthInitializerProps = {
    children: ReactNode;
}

// 새로고침 시 액세스 토큰은 메모리에서 사라지므로,
// 직전 인증 상태였다면 쿠키 기반 refresh로 토큰을 재발급받아 세션을 복원한다.
const AuthInitializer = ({ children }: AuthInitializerProps) => {
    const { isAuthenticated, setAdmin, setIsLoading, logout } = useAuthStore();
    const initialized = useRef(false);

    useEffect(() => {
        if (initialized.current) return;
        initialized.current = true;

        const restoreSession = async () => {
            // 비인증 상태면 복원할 세션이 없으므로 즉시 로딩 종료
            if (!isAuthenticated) {
                setIsLoading(false);
                return;
            }

            try {
                await refreshAccessToken(); // 내부에서 setAccessToken 처리
                const me = await adminAuthControllerMe();
                setAdmin(me);
            } catch {
                logout();
            } finally {
                setIsLoading(false);
            }
        };

        restoreSession();
    }, [isAuthenticated, setAdmin, setIsLoading, logout]);

    return children;
};

export default AuthInitializer;
